import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AppCalendarEvent } from '../app-calendar-event.type';

@Component({
    selector: 'app-calendar-modal',
    templateUrl: './calendar-modal.component.html',
    styleUrls: ['./calendar-modal.component.scss'],
    standalone: false
})
export class CalendarModalComponent {
  eventType: AppCalendarEvent;

  constructor(
    private dialogRef: MatDialogRef<CalendarModalComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: AppCalendarEvent
  ) {
    this.eventType = data;
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onSelectCalendarEvent(calendarEvent) {
    this.eventType = 'calendarEvent';
    let eventInfo = {
      eventType: this.eventType,
      eventId: calendarEvent.id,
      eventTitle: calendarEvent.title,
    };
    this.dialogRef.close(eventInfo);
  }

  onSelectCalenderOrganizationEvents(calendarOrganizationEvent) {
    this.eventType = 'calendarOrganizationEvent';
    let eventInfo = {
      eventType: this.eventType,
      eventId: calendarOrganizationEvent.id,
      eventTitle: calendarOrganizationEvent.title,
    };
    this.dialogRef.close(eventInfo);
  }

  onClose() {
    this.dialogRef.close();
  }
}
